import React from 'react';
import { COMPONENT_TYPES } from '../../../constants';
import ProductDetailEditor from './ProductDetail.editor';
import ProductDetailProperties from './ProductDetail.properties';
import { registerComponent, registerSkinnableComponent } from '../registry';
import { ProductDetailSkinnable } from './ProductDetailSkinnable';
import ComponentSkinWrapper from '../../skins/ComponentSkinWrapper';

// 스킨 가능한 컴포넌트로 등록
registerSkinnableComponent(ProductDetailSkinnable);

// 외부 스킨 지원을 위한 래퍼 컴포넌트
const ProductDetailWrapper: React.FC<any> = (props) => {
  const selectedSkin = props.skin || props.componentProps?.skin || 'basic';
  
  return (
    <ComponentSkinWrapper 
      component={ProductDetailSkinnable}
      componentData={props}
      skinId={selectedSkin}
      mode={props.isPreview ? 'editor' : 'preview'}
      editorProps={props}
    />
  );
};

// 레지스트리에 컴포넌트 등록
registerComponent({
  type: COMPONENT_TYPES.PRODUCT_DETAIL, // constants.js에 정의된 타입 상수 사용
  component: ProductDetailWrapper,
  editorComponent: ProductDetailEditor,
  properties: ProductDetailProperties, // 직접 변수 참조
  defaultProps: {
    // 기본 속성 정의
    style: {
      backgroundColor: '#fff',
      width: '100%',
      maxWidth: '100%',
      padding: '40px 0',
    },
    componentProps: {
      productId: 0,
      order: '',
      none: 'none',
      lg: 9,
      showDescriptionTab: true,
      showReviewsTab: true,
      showSpecificationTab: true,
      showStock: false,
      skin: 'basic',
      showRelatedProducts: true,
      showQuantitySelector: true,
      showAddToCart: true,
      showBuyNow: true,
      addToCartButtonColor: '#007bff',
      buyNowButtonColor: '#28a745',
      priceColor: '#ff6b6b',
      stockTextColor: '#28a745'
    }
  },
  category: 'shop', // 컴포넌트 카테고리
  icon: '🛒', // 대표 아이콘
  name: '상품 상세', // 표시할 이름
  description: '상품 상세 정보를 표시하는 컴포넌트입니다.',
  skinnable: ProductDetailSkinnable
});

// 컴포넌트 및 타입 내보내기
export { ProductDetailWrapper as ProductDetailComponent };
export { default as ProductDetailEditor } from './ProductDetail.editor';
export { default as ProductDetailProperties } from './ProductDetail.properties';
export * from './ProductDetail.types'; 